
import { IconCalendar } from '@ds/icons/IconCalendar'
import { IconCreditCard } from '@ds/icons/IconCreditCard'
import { IconExports } from '@ds/icons/IconExports'
import { IconHeart } from '@ds/icons/IconHeart'
import { IconTools } from '@ds/icons/IconTools'
import isEmpty from 'lodash/isEmpty'

import { MODAL_NAMES } from '@config/constants'
import { productWarrantyServices } from '@http/endpoints'

import AsyncModal from '../../../AsyncModal'
import ContentRow from '../../../ContentRow'

import translations from './PerksModal.translations'

const ICONS = {
  warranty: IconTools,
  return: IconCalendar,
  shipping: IconExports,
  customerCare: IconHeart,
  instalmentPayment: IconCreditCard,
}

export default {
  components: {
    ContentRow,
    AsyncModal,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      warranty: {},
    }
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.PERKS,
    translations: () => translations,

    productId() {
      return this.$route.params.uuid
    },

    services() {
      return (
        this.shouldShowServices &&
        this.warranty.includedServices.map(
          ({ type, title, texts, hyperlink }) => {
            return {
              icon: ICONS[type],
              title,
              texts,
              hyperlink,
            }
          },
        )
      )
    },

    shouldShowServices() {
      return !isEmpty(this.warranty.includedServices)
    },
  },
  methods: {
    async fetchWarrantyServices() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productWarrantyServices,
        pathParams: {
          id: this.productId,
          listingId: this.listingId,
        },
      })

      this.warranty = payload
    },
  },
}
